var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file RadioButtonGroup
 * @author (v_lichaoqing)
 */

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash-es';

import { inputLoop, classPrefix, EleResize } from '../../common/util';

import RadioButton from './RadioButton';

import './RadioButtonGroup.less';
/* global getComputedStyle */

/**
 * 参数说明
 * value                可选，RadioButtonGroup 选中的值
 * onHandleChange       可选，onHandleChange 切换radioButton时触发
 * name                 可选，一组radioButton的name
 * label                可选，label说明
 * star                 可选，是否必填的*号
 * tips                 可选，后面的说明文字
 * noWarning            可选，不要提示警告
 * horizontal           可选，水平排列
 * noDistance           可选，此项为true，RadioButtonGroup下的24px消失
 * increment            可选，form专用
 * className            可选，RadioButtonGroup 追加类名
 * formFlag             可选，form专用
 * validate             可选, form专用
 */

var RadioButtonGroup = function (_Component) {
    _inherits(RadioButtonGroup, _Component);

    function RadioButtonGroup(props) {
        _classCallCheck(this, RadioButtonGroup);

        var _this = _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            name = _this$props.name,
            value = _this$props.value;

        var loop = inputLoop();
        _this.state = {
            layout: false
        };
        _this.__name = !name ? loop : name;

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;

        _this.formCallback(value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(RadioButtonGroup, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.value, this.props.value)) {
                this.formCallback(np.value, this.FORM_NEED_VALIDATE);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var responsive = this.props.responsive;
            if (!responsive) {
                // 如果是垂直布局或者非响应式模式，直接跳过
                return;
            }
            // 获取横向宽度
            var children = this.groupWrapper.querySelectorAll('.' + classPrefix + '-radio-button-root');
            var childrenWidth = 0;
            for (var i = 0; i < children.length; i++) {
                childrenWidth += parseFloat(getComputedStyle(children[i]).width);
            }
            this.childrenWidth = childrenWidth;

            this.resizeHandler();
            EleResize.on(this.groupWrapper, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);

            var responsive = this.props.responsive;
            if (!responsive) {
                // 如果是垂直布局或者非响应式模式，直接跳过
                return;
            }
            EleResize.off(this.groupWrapper, this.resizeHandler);
        }
    }, {
        key: 'tplRadioButton',
        value: function tplRadioButton(objRadioButton) {
            var value = objRadioButton.value,
                disabled = objRadioButton.disabled,
                name = objRadioButton.name,
                checked = objRadioButton.checked,
                label = objRadioButton.label;

            var responsive = this.props.responsive;
            var layout = this.state.layout;
            if (responsive && layout) {
                return React.createElement(
                    'div',
                    { key: value },
                    React.createElement(
                        RadioButton,
                        _extends({ value: value, disabled: disabled, name: name }, {
                            checked: value === checked,
                            onHandleChange: this.onHandleChange
                        }),
                        label
                    )
                );
            }
            return React.createElement(
                RadioButton,
                _extends({ value: value, disabled: disabled, name: name }, {
                    key: value,
                    checked: value === checked,
                    onHandleChange: this.onHandleChange
                }),
                label
            );
        }
    }, {
        key: 'renderRadioButton',
        value: function renderRadioButton() {
            var _this2 = this;

            var res = [];
            var _props = this.props,
                children = _props.children,
                options = _props.options,
                value = _props.value;

            var propsValue = value;
            if (options.length !== 0) {
                res = options.map(function (item) {
                    var name = item.name,
                        value = item.value,
                        disabled = item.disabled;

                    var objRadioButton = {
                        value: name,
                        label: value,
                        disabled: disabled,
                        checked: propsValue,
                        name: _this2.__name
                    };

                    return _this2.tplRadioButton(objRadioButton);
                });
            } else {
                res = React.Children.map(children, function (item) {
                    var _item$props = item.props,
                        value = _item$props.value,
                        children = _item$props.children,
                        disabled = _item$props.disabled;

                    var objRadioButton = {
                        value: value,
                        label: children,
                        disabled: disabled,
                        checked: propsValue,
                        name: _this2.__name
                    };

                    return _this2.tplRadioButton(objRadioButton);
                });
            }
            if (this.state.layout) {
                return React.createElement(
                    'div',
                    { className: 'radio-button-width-wrapper' },
                    res
                );
            }
            return res;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var _props2 = this.props,
                className = _props2.className,
                label = _props2.label,
                star = _props2.star,
                tips = _props2.tips,
                noWarning = _props2.noWarning,
                validate = _props2.validate,
                horizontal = _props2.horizontal,
                style = _props2.style,
                classPrefix = _props2.classPrefix,
                responsive = _props2.responsive,
                shape = _props2.shape;

            var groupClassName = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-radio-button-group', true), _defineProperty(_classnames, className, className), _defineProperty(_classnames, 'display-i-b', horizontal), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _defineProperty(_classnames, 'responsive', responsive), _defineProperty(_classnames, 'radio-button-square', shape === 'square'), _classnames));
            var extendsStyle = style ? style : {};

            return React.createElement(
                'div',
                { className: groupClassName, style: extendsStyle },
                label && React.createElement(
                    'span',
                    { className: classPrefix + '-form-label' },
                    label
                ),
                React.createElement(
                    'span',
                    {
                        className: classPrefix + '-radio-button-group-warp',
                        ref: function ref(el) {
                            _this3.groupWrapper = el;
                        }
                    },
                    this.renderRadioButton(),
                    !noWarning && validate && validate.message && React.createElement(
                        'div',
                        { className: classPrefix + '-form-warning' },
                        React.createElement('i', { className: classPrefix + '-form-error' }),
                        validate.message
                    )
                ),
                star && React.createElement(
                    'span',
                    { className: classPrefix + '-input-star' },
                    '*'
                ),
                tips && React.createElement(
                    'span',
                    { className: classPrefix + '-form-tips' },
                    tips
                )
            );
        }
    }]);

    return RadioButtonGroup;
}(Component);

RadioButtonGroup.propTypes = {
    formFlag: PropTypes.bool,
    increment: PropTypes.string,
    name: PropTypes.string,
    onHandleChange: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    star: PropTypes.bool,
    tips: PropTypes.node,
    noWarning: PropTypes.bool,
    horizontal: PropTypes.bool,
    noDistance: PropTypes.bool,
    value: PropTypes.string,
    validate: PropTypes.object,
    getValue: PropTypes.func,
    children: PropTypes.array,
    options: PropTypes.array,
    style: PropTypes.object,
    classPrefix: PropTypes.string,
    responsive: PropTypes.bool,
    shape: PropTypes.oneOf(['square', 'circular'])
};
RadioButtonGroup.defaultProps = {
    classPrefix: classPrefix,
    options: [],
    shape: 'circular'
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.resizeHandler = function () {
        var wrapperWidth = parseFloat(getComputedStyle(_this4.groupWrapper).width);

        var layout = wrapperWidth <= _this4.childrenWidth;

        if (layout !== _this4.state.layout) {
            _this4.setState({ layout: layout });
        }
    };

    this.formCallback = function (data, type, isDelete) {
        var _props3 = _this4.props,
            formFlag = _props3.formFlag,
            name = _props3.name,
            increment = _props3.increment,
            onHandleChange = _props3.onHandleChange;


        if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
            onHandleChange({
                name: name,
                value: data
            }, _this4, type, increment, isDelete);
        }
    };

    this.onHandleChange = function (e) {
        var value = e.target.value;
        var getValue = _this4.props.getValue;
        if (getValue && _.isFunction(getValue)) {
            getValue({
                name: _this4.__name,
                value: value
            });
        }
    };
};

export default RadioButtonGroup;